import { physiqueCommonInstance } from '../service/physique.service';
import { corporateCommonInstance } from '../service/corporate.service';
import { clearLocalStorage } from './localStorage';
import { BOOKING_STORAGE_DATA } from '../components/membership/constants';

export const TOKEN_TYPE = {
  PHYSIQUE_ACCESS: 'physique_access',
  PHYSIQUE_SPARE: 'physique_spare',
  CORPORATE_ACCESS: 'corporate_access',
  CORPORATE_SPARE: 'corporate_spare',
};

export const STORAGE_DATA = {
  FULL_NAME: 'fullname',
  CORPORATE_FULL_NAME: 'corporate_fullname',
  MEMBERSHIP_IMAGE: 'membershipImage',
  MEMBERSHIP_Id: 'membershipId',
};

export const IsPhysiqueAuthorized = () => {
  return checkIsAuthorized(TOKEN_TYPE.PHYSIQUE_ACCESS);
};

export const IsCorporateAuthorized = () => {
  return checkIsAuthorized(TOKEN_TYPE.CORPORATE_ACCESS);
};

export const checkIsAuthorized = (token) => {
  return !!localStorage.getItem(token);
};

export const clearLocalPhysiqueStorage = () => {
  clearLocalStorage([
    TOKEN_TYPE.PHYSIQUE_SPARE,
    TOKEN_TYPE.PHYSIQUE_ACCESS,
    STORAGE_DATA.FULL_NAME,
    STORAGE_DATA.MEMBERSHIP_IMAGE,
    STORAGE_DATA.MEMBERSHIP_Id,
    BOOKING_STORAGE_DATA.BOOKING_DATA,
    BOOKING_STORAGE_DATA.BOOKING_QUERY,
  ]);
};

export const clearLocalCorporateStorage = () => {
  clearLocalStorage([TOKEN_TYPE.CORPORATE_ACCESS, TOKEN_TYPE.CORPORATE_SPARE, STORAGE_DATA.FULL_NAME]);
};

export const getPhysiqueTokenFromLocalStorage = () =>
  localStorage.getItem(TOKEN_TYPE.PHYSIQUE_ACCESS) || localStorage.getItem(TOKEN_TYPE.PHYSIQUE_SPARE);

export const getCorporateTokenFromLocalStorage = () =>
  localStorage.getItem(TOKEN_TYPE.CORPORATE_ACCESS) || localStorage.getItem(TOKEN_TYPE.CORPORATE_SPARE);

export async function getToken(isPhysique) {
  const token = isPhysique ? getPhysiqueTokenFromLocalStorage() : getCorporateTokenFromLocalStorage();
  if (token) {
    return token;
  }

  const instance = isPhysique ? physiqueCommonInstance : corporateCommonInstance;

  return instance.get('').then((res) => {
    return res.data;
  });
}

export async function buildRequest(request, isPhysique) {
  const token = await getToken(isPhysique);
  if (token) {
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return request;
}
